import React, { useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetch_contact } from '@store/contact.slice';
import TypedText from '@components/TypedText';

const Contact = () => {
  const { contact, is_fetching_contact } = useSelector(
    (state) => state.contact,
  );
  const dispatch = useDispatch();
  useEffect(() => {
    if (Object.keys(contact).length === 0 && contact.constructor === Object) {
      fetch();
    }
  }, []);

  const fetch = async () => {
    await dispatch(fetch_contact());
  };

  return (
    <>
      {!(
        Object.keys(contact).length === 0 && contact.constructor === Object
      ) && (
        <div
          class="page-2"
          oncopy="return false"
          onpaste="return false"
          oncut="return false"
        >
          <div class="page-2-left-column">
            <div dangerouslySetInnerHTML={{ __html: contact.left_column }} />
          </div>
          <div class="page-2-right-column">
            <div dangerouslySetInnerHTML={{ __html: contact.right_column }} />
          </div>
        </div>
      )}
    </>
  );
};

export default Contact;
